import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Lock } from 'lucide-react';
interface NavbarProps {
  onLoginClick: () => void;
}
export function Navbar({
  onLoginClick
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Strategies',
    href: '#strategies'
  }, {
    name: 'LP Resources',
    href: '#lp-resources'
  }];
  const scrollToSection = (href: string) => {
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 border-b ${isScrolled ? 'bg-base-950/90 backdrop-blur-md border-slate-800 py-4' : 'bg-transparent border-transparent py-6'}`} data-id="element-197">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-198">
        {/* Logo */}
        <div className="text-xl font-bold tracking-[0.2em] text-white cursor-pointer flex items-center gap-2" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-199">
          <div className="w-6 h-6 bg-gold-400" style={{
          clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)'
        }} data-id="element-200"></div>
          DELTA STREET
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-201">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="text-sm text-slate-400 hover:text-white transition-colors tracking-wide" data-id="element-202">
              {link.name}
            </button>)}
          <button onClick={onLoginClick} className="flex items-center gap-2 px-5 py-2.5 border border-slate-700 text-slate-300 text-sm tracking-wide hover:border-gold-400/50 hover:text-gold-300 transition-all duration-300" data-id="element-203">
            <Lock className="w-3.5 h-3.5" data-id="element-204" />
            Investor Login
          </button>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-205">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-206" /> : <Menu className="w-6 h-6" data-id="element-207" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-208">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-base-950 border-b border-slate-800 overflow-hidden" data-id="element-209">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-210">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.href)} className="text-left text-sm text-slate-400 hover:text-white tracking-wide py-2" data-id="element-211">
                  {link.name}
                </button>)}
              <button onClick={() => {
            setIsMobileMenuOpen(false);
            onLoginClick();
          }} className="flex items-center justify-center gap-2 w-full px-5 py-3 mt-2 border border-slate-700 text-slate-300 text-sm tracking-wide" data-id="element-212">
                <Lock className="w-4 h-4" data-id="element-213" />
                Investor Login
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}